// store/modules/user.js



export default {
    namespaced: true, // 命名空间模块化
    state: () => ({
        TextList: []
    }),
    mutations: {
        SET_TEXT_LIST: (state, TextList) => {
            state.TextList = TextList;
        },
       
    },
    actions: {
        setTextList({ commit }, TextList) {
            commit("SET_TEXT_LIST", TextList);
        },
     
    }
};
